import { render, staticRenderFns } from "./EmailReportingV1.vue?vue&type=template&id=72f5eeba&scoped=true&lang=pug"
import script from "./EmailReportingV1.vue?vue&type=script&lang=js"
export * from "./EmailReportingV1.vue?vue&type=script&lang=js"
import style0 from "./EmailReportingV1.vue?vue&type=style&index=0&id=72f5eeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5eeba",
  null
  
)

export default component.exports